import { render, staticRenderFns } from "./RecordsCount.vue?vue&type=template&id=0f5ebace&scoped=true&"
import script from "./RecordsCount.vue?vue&type=script&lang=js&"
export * from "./RecordsCount.vue?vue&type=script&lang=js&"
import style0 from "./RecordsCount.vue?vue&type=style&index=0&id=0f5ebace&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5ebace",
  null
  
)

export default component.exports